export default __webpack_public_path__ + "static/media/mainPic.84c51fc6.jpg";